import { render } from "./entryBefore.vue?vue&type=template&id=afc8bd22&scoped=true"
import script from "./entryBefore.vue?vue&type=script&lang=js"
export * from "./entryBefore.vue?vue&type=script&lang=js"

import "./entryBefore.vue?vue&type=style&index=0&id=afc8bd22&lang=scss&scoped=true"
import "./entryBefore.vue?vue&type=style&index=1&id=afc8bd22&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc8bd22"]])

export default __exports__